export function validatePassword(password) {
  if (!password || password.length < 8) return false;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasDigit = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*]/.test(password);

  const passedCriteria = [
    hasUpperCase,
    hasLowerCase,
    hasDigit,
    hasSpecialChar,
  ].filter(Boolean).length;
  return passedCriteria >= 3;
}
